import { humanizedTimeRange } from "helpers/date";
import { carStopMarkerStyle } from "helpers/map";
import React from "react";
import { CircleMarker, Tooltip } from "react-leaflet";

export default function CarStopPoint({ carStop }) {
    if (!carStop) {
        return null;
    }

    const { location, duration } = carStop;
    const loc = [location[1], location[0]];
    const stopDuration = humanizedTimeRange(duration, "d [д.] h [ч.] m [мин.]");

    return (
        <CircleMarker center={loc} {...carStopMarkerStyle} pane="markerPane">
            <Tooltip className="map__tooltip--default" direction="top">
                <span>
                    <b>Остановка машины</b>
                    <br />
                    {stopDuration}
                </span>
            </Tooltip>
        </CircleMarker>
    );
}
